<template>
  <div class="border-wrap">
    <slot />
    <img
      v-if="borderParams"
      class="border-img"
      :style="{ width: `${borderParams.scale * 100}%`, height: `auto` }"
      :src="borderParams.url"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    borderMethod: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters(['avatarBorder']),
    borderParams() {
      const { borderMethod, avatarBorder } = this
      if (!borderMethod || !avatarBorder) return null
      switch (borderMethod) {
        case 1: { // 旧最强守护头像框
          return {
            scale: avatarBorder.guardRate,
            url: avatarBorder.guardImage,
          }
        }
        case 2: { // 羁绊头像框
          return {
            scale: avatarBorder.jiRate,
            url: avatarBorder.jiImage,
          }
        }
        case 3: { // 相互守护头像框
          return {
            scale: 1.7,
            url: avatarBorder.guardOneImage,
          }
        }
        case 4: { // 新版一级守护头像框
          return {
            scale: 1.5,
            url: avatarBorder.guardImageLevel1,
          }
        }
        case 5: { // 新版二级守护头像框
          return {
            scale: 1.5,
            url: avatarBorder.guardImageLevel2,
          }
        }
        case 6: { // 新版三级守护头像框
          return {
            scale: 1.5,
            url: avatarBorder.guardImageLevel3,
          }
        }
        case 7: { // 情人守护头像框
          return {
            scale: 1.5,
            url: avatarBorder.guardImageLevel4,
          }
        }
        default: return {}
      }
    },
  }
}
</script>
<style lang="scss" scoped>
  .border-wrap {
    width: 100%;
    height: 100%;
    position: relative;
    .border-img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      pointer-events: none;
    }
  }
</style>
